// +----------------------------------------------------------------------
// | 路由配置文件
// +----------------------------------------------------------------------
// | Copyright (c) 2018 安徽秒速科技有限公司 All rights reserved.
// +----------------------------------------------------------------------
// | Author：tangfei <957987132@qq.com>
// +----------------------------------------------------------------------

import Vue from "vue";
import iView from "iview";
import VueRouter from "vue-router";
import Routers from "./routers";
import store from "./store";

Vue.use(VueRouter);

// 路由配置
const RouterConfig = {
  mode: "hash", //hash history
  routes: Routers
};

const router = new VueRouter(RouterConfig);

//配置进度条颜色
iView.LoadingBar.config({
  color: "#edcb2c"
});

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  Vue.prototype.$func.title(to.meta.title);
  store.commit('setRouteTo',to);
  // 判断是否已经登录且前往的页面不是登录页
  if(Vue.prototype.$func.data.get("userInfo")){
      if(to.name == "policy" ||to.name === "main"  || to.name === "login" || to.name === "fastlogin" || to.name === "regist"  || to.name === "bindphone"  || to.name === "forgetpassword"){
          // 判断是否已经登录且前往的是登录页
          next({
              name: "index"
          });
      }else{
          next();
      }

  }else if (!Vue.prototype.$func.data.get("userInfo")) {
      if(to.name == "policy" ||to.name == "login" || to.name == "regist" || to.name == "bindphone" || to.name == "fastlogin" || to.name == "forgetpassword"){
          next();
      }else{
          next({
              name:'login'
          });
      }
  } else {
    next();
  }
});

router.afterEach(() => {
  iView.LoadingBar.finish();
  window.scrollTo(0, 0);
});

export default router;
